var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { DateTime } from 'luxon';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Event as EventModel } from '@/models/Event';
import { formatDate as format } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { DateTimeslot } from '@/models/DateTimeslot';
import CreateEventDialog from './CreateEventDialog';
let ShowEventsDialog = class ShowEventsDialog extends Vue {
    constructor() {
        super(...arguments);
        this.visibility = {
            checkboxes: false,
            search: false,
        };
        this.newDateTimeSlot = null;
        this.selectedDateTimeSlot = null;
        this.selectedEvent = null;
        this.isEditing = false;
        this.datetimeslotChanged = false;
        this.isCreatingEventDialog = false;
        this.audits = [];
        this.showAudits = false;
    }
    get deleteTimeSlot() {
        return {
            title: 'timeslot' || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.timeslot') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.newDateTimeSlot) {
                            return;
                        }
                        this.newDateTimeSlot
                            .delete()
                            .then(() => {
                            this.$emit('dateTimeslotRemoved');
                            this.$emit('input', false);
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedDateTimeSlot = null;
                    },
                },
            },
        };
    }
    get auditCount() {
        let errorCount = 0;
        let warningCount = 0;
        if (this.audits.length) {
            this.audits.forEach((audit) => {
                if (audit.severity === 'error') {
                    errorCount += 1;
                }
                else if (audit.severity === 'warning') {
                    warningCount += 1;
                }
            });
        }
        return {
            total: errorCount + warningCount,
            errors: errorCount,
            warnings: warningCount,
        };
    }
    get tableOptionsEvents() {
        return {
            name: {
                singular: this.$tc('rosterTemplate.dialog.header.activities', 1),
                plural: this.$tc('rosterTemplate.dialog.header.activities', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'datetimeslots',
                    width: '3px',
                    style: { position: 'relative' },
                    transform: (value, event) => {
                        return event.meta && event.meta.totals && event.meta.totals.datetimeslots > 1 ? `<div class="doublePeriodLine"></div>` : '';
                    },
                },
                {
                    text: '',
                    value: 'avatar',
                    transform: (value, event) => {
                        if (!event.teacher) {
                            return '';
                        }
                        return `<img class="avatar avatar-small" src="${event.teacher.avatar}">`;
                    },
                },
                {
                    text: this.$tc('roles.teacher', 1),
                    value: 'teacher',
                    transform: (value, event) => {
                        if (!event.teacher) {
                            return '';
                        }
                        return `${event.teacher.name}`;
                    },
                },
                {
                    text: this.$tc('subject.area.title', 1),
                    value: 'areas',
                    transform: (areas, event) => {
                        if (event.type === 'recess') {
                            return 'RECESS';
                        }
                        let str = '';
                        areas.forEach((area) => { str += `${area.name}, `; });
                        return str.substring(0, str.length - 2);
                    },
                },
                {
                    text: this.$tc('subject.topic.title', 1),
                    value: 'topics',
                    transform: (topics, activity) => {
                        if (activity.type === 'recess') {
                            return '';
                        }
                        let str = '';
                        topics.forEach((topic) => { str += `${topic.name}, `; });
                        return str.substring(0, str.length - 2);
                    },
                },
                {
                    text: this.$tc('room.title', 1),
                    value: 'room',
                    transform: (room) => {
                        return room ? room.name : '';
                    },
                },
                {
                    text: this.$tc('level.title', 2),
                    value: 'levels',
                    transform: (levels) => {
                        let str = '';
                        levels.forEach((level) => { str += `${level.name}, `; });
                        return `<span class="${levels[0] && levels[0].is_mandatory ? 'is_mandatory' : ''}">${str.substring(0, str.length - 2)}</span>`;
                    },
                },
                {
                    text: this.$tc('group.title', 2),
                    value: 'groups',
                    transform: (groups) => {
                        let str = '';
                        groups.forEach((group) => { str += `${group.name}, `; });
                        return `<span class="${groups[0] && groups[0].is_mandatory ? 'is_mandatory' : ''}">${str.substring(0, str.length - 2)}</span>`;
                    },
                },
                {
                    text: this.$tc('roles.student', 2),
                    value: 'meta',
                    transform: (meta) => {
                        if (meta.totals && meta.totals.students) {
                            return `${meta.totals.students} ${this.$tc('roles.student', meta.totals.students)}`;
                        }
                        return 'n/a';
                    },
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    action: (vm, event) => {
                        this.selectedEvent = event;
                        this.isCreatingEventDialog = true;
                    },
                    visible: this.isActionVisible,
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, event) => {
                        this.handleTableDelete(event);
                    },
                    visible: this.isActionVisible,
                },
            ],
            filters: [],
            model: new EventModel().include(['users', 'teacher', 'subjects', 'areas', 'topics', 'levels', 'groups', 'room', 'meta']).filter('datetimeslots', [this.datetimeslot.id] || []),
        };
    }
    get isActionVisible() {
        return this.isEditable;
    }
    get deleteEvent() {
        const event = this.selectedEvent;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.activity') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!event) {
                            return;
                        }
                        event
                            .delete({ validate: false })
                            .then(() => {
                            this.selectedEvent = null;
                            this.refreshDataTable();
                            this.$emit('eventRemoved');
                            this.datetimeslotChanged = true;
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedEvent = null;
                    },
                },
            },
        };
    }
    mounted() {
        this.datetimeslotChanged = false;
    }
    close() {
        if (this.datetimeslotChanged) {
            this.$emit('refreshEvents');
        }
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.newDateTimeSlot = null;
        this.showAudits = false;
    }
    refreshDataTable() {
        this.datetimeslotChanged = true;
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    datetimeslotsForDay(date) {
        const day = DateTime.fromSQL(date).weekday;
        return this.datetimeslots.filter((datetimeslot) => {
            const filterDay = DateTime.fromSQL(datetimeslot.starts_at || '').weekday;
            return filterDay === day;
        });
    }
    parseAuditMessage(audit) {
        if (!audit.code) {
            return '';
        }
        let message = '';
        let name = '';
        switch (audit.code) {
            case 'activity.missing':
                message = this.$t(`rosterAudits.${audit.code}`).toString();
                break;
            case 'event.missing':
                message = this.$t(`rosterAudits.${audit.code}`).toString();
                break;
            case 'teacher.absent':
                message = this.$t(`rosterAudits.${audit.code}`).toString();
                break;
            case 'teacher.occupied':
                name = audit.meta && audit.meta.teacher && audit.meta.teacher.name ? audit.meta.teacher.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'teacher.occupied':
                name = audit.meta && audit.meta.teacher && audit.meta.teacher.name ? audit.meta.teacher.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'teacher.vacation':
                name = audit.meta && audit.meta.teacher && audit.meta.teacher.name ? audit.meta.teacher.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.occupied':
                name = audit.meta && audit.meta.group && audit.meta.group.name ? audit.meta.group.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.unassigned':
                name = audit.meta && audit.meta.group && audit.meta.group.name ? audit.meta.group.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.missing':
                name = audit.meta && audit.meta.group && audit.meta.group.name ? audit.meta.group.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'group.recess':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.occupied':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.unassigned':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.missing':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'level.recess':
                name = audit.meta && audit.meta.level && audit.meta.level.name ? audit.meta.level.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            case 'room.occupied':
                name = audit.meta && audit.meta.room && audit.meta.room.name ? audit.meta.room.name : '';
                message = this.$t(`rosterAudits.${audit.code}`, { name }).toString();
                break;
            default:
                break;
        }
        return message;
    }
    update() {
        if (!this.newDateTimeSlot) {
            return;
        }
        this.newDateTimeSlot
            .update()
            .then((datetimeslot) => {
            this.newDateTimeSlot = datetimeslot.clone();
            this.$emit('timeslotUpdated', datetimeslot);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    remove() {
        this.$store.dispatch('openDialog', this.deleteTimeSlot);
    }
    cancel() {
        // this.isEditingEvent = false;
    }
    fetchAudits() {
        if (!this.datetimeslot || !this.datetimeslot.id) {
            return;
        }
        this.audits = [];
        this.datetimeslot.audit().then((audits) => {
            this.audits = audits;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    handleTableDelete(event) {
        this.selectedEvent = event;
        this.$store.dispatch('openDialog', this.deleteEvent);
    }
    timeslotChanged(dateTimeslot) {
        if (dateTimeslot) {
            this.newDateTimeSlot = dateTimeslot.clone();
            this.fetchAudits();
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof DateTimeslot !== "undefined" && DateTimeslot) === "function" ? _a : Object)
], ShowEventsDialog.prototype, "datetimeslot", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], ShowEventsDialog.prototype, "isEditable", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], ShowEventsDialog.prototype, "datetimeslots", void 0);
__decorate([
    Watch('datetimeslot'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof DateTimeslot !== "undefined" && DateTimeslot) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], ShowEventsDialog.prototype, "timeslotChanged", null);
ShowEventsDialog = __decorate([
    Component({
        components: {
            SelectFilter,
            DataTable,
            CreateEventDialog,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
            formatDay(date) {
                return !date ? '' : format(date, 'cccc');
            },
        },
    })
], ShowEventsDialog);
export default ShowEventsDialog;
